// Small inline SVG icon set. 16×16 viewBox, current-color stroke.

function svg(d: string, opts: { strokeWidth?: number; fill?: string } = {}): string {
  const sw = opts.strokeWidth ?? 1.5;
  const fill = opts.fill ?? 'none';
  return `<svg viewBox="0 0 16 16" width="14" height="14" fill="${fill}" stroke="currentColor" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
}

export const ICON = {
  plus: svg('<path d="M8 3v10M3 8h10"/>'),
  trash: svg(
    '<path d="M3 4h10M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M4 4l1 9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l1-9"/>',
  ),
  eye: svg('<path d="M1.5 8s2.5-4.5 6.5-4.5 6.5 4.5 6.5 4.5-2.5 4.5-6.5 4.5S1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/>'),
  eyeOff: svg(
    '<path d="M2 2l12 12M9.5 9.5a2 2 0 0 1-3-3M6 4.2A6.7 6.7 0 0 1 8 3.5c4 0 6.5 4.5 6.5 4.5a13 13 0 0 1-2 2.5M3.5 5.5A12 12 0 0 0 1.5 8s2.5 4.5 6.5 4.5c.7 0 1.4-.1 2-.3"/>',
  ),
  undo: svg('<path d="M3 8a5 5 0 0 1 9.5-2L13 4M13 4l-1 2.5M13 4l-2.5.5"/>'),
  redo: svg('<path d="M13 8a5 5 0 0 0-9.5-2L3 4M3 4l1 2.5M3 4l2.5.5"/>'),
  share: svg(
    '<circle cx="4" cy="8" r="1.5"/><circle cx="12" cy="3.5" r="1.5"/><circle cx="12" cy="12.5" r="1.5"/><path d="M5.3 7.3l5.4-3M5.3 8.7l5.4 3"/>',
  ),
  download: svg('<path d="M8 2v8M4 7l4 4 4-4M2 14h12"/>'),
  shuffle: svg(
    '<path d="M2 4h2.5l7 8H14M2 12h2.5l7-8H14M11 2l3 2-3 2M11 10l3 2-3 2"/>',
  ),
  sun: svg(
    '<circle cx="8" cy="8" r="3"/><path d="M8 1v1M8 14v1M1 8h1M14 8h1M3 3l.7.7M12.3 12.3l.7.7M3 13l.7-.7M12.3 3.7l.7-.7"/>',
  ),
  moon: svg('<path d="M13 9.5A6 6 0 1 1 6.5 3a5 5 0 0 0 6.5 6.5z"/>'),
  drag: svg('<circle cx="6" cy="4" r=".75"/><circle cx="10" cy="4" r=".75"/><circle cx="6" cy="8" r=".75"/><circle cx="10" cy="8" r=".75"/><circle cx="6" cy="12" r=".75"/><circle cx="10" cy="12" r=".75"/>', { fill: 'currentColor', strokeWidth: 0 }),
  square: svg('<rect x="2" y="2" width="12" height="12"/>'),
  layer: svg('<path d="M8 1l6 3-6 3-6-3 6-3zM2 8l6 3 6-3M2 12l6 3 6-3"/>'),
  filter: svg('<path d="M2 3h12L9.5 8.5V13l-3 1.5V8.5z"/>'),
  copy: svg('<rect x="5" y="5" width="9" height="9" rx="1"/><path d="M11 5V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2"/>'),
  resize: svg('<path d="M2 6V2h4M14 10v4h-4M2 2l5 5M14 14l-5-5"/>'),
  zoomIn: svg('<circle cx="7" cy="7" r="4"/><path d="M10 10l4 4M5 7h4M7 5v4"/>'),
  zoomOut: svg('<circle cx="7" cy="7" r="4"/><path d="M10 10l4 4M5 7h4"/>'),
  code: svg('<path d="M5 4l-3 4 3 4M11 4l3 4-3 4M9.5 3l-3 10"/>'),
  palette: svg('<path d="M8 1c4 0 7 2.5 7 6 0 2-1.5 3-3 3h-1c-1 0-1 .5-1 1.5s1 1.5 1 2.5c0 1-1 1-2 1-3.5 0-7-2.5-7-7 0-3.5 2-7 6-7zM5 6.5a1 1 0 1 1 0-.1zm3-2a1 1 0 1 1 0-.1zm3 2a1 1 0 1 1 0-.1zm1 3a1 1 0 1 1 0-.1z"/>'),
  check: svg('<path d="M3 8.5l3.5 3.5L13 5"/>'),
};
